import { render, staticRenderFns } from "./accountsReceivableStatistics.vue?vue&type=template&id=2a4e656a&scoped=true"
import script from "./accountsReceivableStatistics.vue?vue&type=script&lang=js"
export * from "./accountsReceivableStatistics.vue?vue&type=script&lang=js"
import style0 from "./accountsReceivableStatistics.vue?vue&type=style&index=0&id=2a4e656a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4e656a",
  null
  
)

export default component.exports